module.exports = __webpack_public_path__ + "img/mobile-03.488e68d5.png";